export const propPoliciesRoomsHc = {
  policies: {
    breadcrumb: `Polityka prywatności`,
    cloneTitleNoun: `zasady obiektu`,
    cloneItemNoun: `zasady`,
    editorHintLang: `Polityka prywatności w wersji: {label}`,
    optional: `(opcjonalnie)`,
    headingOpt1: `Nagłówek 1`,
    headingOpt2: `Nagłówek 2`,
    headingOpt3: `Nagłówek 3`,
    headingNormal: `Normalny`,
    tipBold: `Pogrubienie`,
    tipItalic: `Kursywa`,
    tipUnderline: `Podkreślenie`,
    tipListOrdered: `Lista numerowana`,
    tipListBullet: `Lista punktowana`,
    tipLink: `Link`,
    tipQuote: `Cytat`,
    tipClean: `Wyczyść formatowanie`,
    charCount: `{count} znak | {count} znaki | {count} znaków`,
    saving: `Zapisywanie…`,
    editorPlaceholder: `Tutaj należy wpisać politykę prywatności w wersji: {label}…`,
    errNoListing: `Nie znaleziono oferty.`,
    errLoad: `Nie udało się wczytać polityki prywatności.`,
    errEsRequired: `Polityka w języku hiszpańskim jest wymagana.`,
    saveSuccess: `Polityka prywatności została zapisana.`,
    saveError: `Błąd podczas zapisywania zasad.`,
  },
  rooms: {
    bulkTitle: `Utwórz pokoje zbiorczo`,
    bulkSubtitle: `Generowanie wielu pokoi dla danego typu, z automatycznym kodem i opcjonalnym opisem.`,
    available: `Dostępne: {count}`,
    willCreate: `Do utworzenia: {count}`,
    needTypeFirst: `Aby wygenerować pokoje, należy najpierw utworzyć co najmniej jeden <b>Typ pokoju</b>.`,
    labelType: `Typ`,
    selectType: `Proszę wybrać typ`,
    labelQuantity: `Ilość`,
    phQuantity: `Np.: 10`,
    labelPrefix: `Prefiks kodu`,
    phPrefix: `Np.: A- lub 10`,
    optional: `Opcjonalne`,
    labelStart: `Początek`,
    labelPadding: `Wypełnienie zerami`,
    labelDescription: `Opis (opcjonalnie)`,
    phDescription: `Zostanie zastosowany do utworzonych pokoi`,
    nameEqType: `Nazwa = Typ`,
    recommended: `(zalecane)`,
    example: `Przykład:`,
    createBulk: `Utwórz zbiorczo`,
    typeFallback: `Typ`,
    previewFormat: `{name} • Kod: {code}`,
    noActivePlan: `Brak aktywnego planu pozwalającego tworzyć pokoje.`,
    limitReached: `Osiągnięto limit: plan dopuszcza {limit} pokoi w tym obiekcie.`,
    selectTypeWarn: `Proszę wybrać typ pokoju.`,
    invalidQuantity: `Proszę podać prawidłową ilość.`,
    cannotAddMore: `Nie można dodać więcej. Limit: {limit}.`,
    partialCreated: `Utworzono tylko {created}, ponieważ plan dopuszcza {limit}, a pozostało {remaining}.`,
    planLimitSave: `Plan dopuszcza {limit} pokoi. Próba zapisania: {count}.`,
  },
  images: {
    zipDownloadTitle: `Pobierz wszystkie zdjęcia obiektu w pliku ZIP`,
    zipNoImages: `Brak zdjęć do pobrania`,
    preparing: `Przygotowywanie…`,
    downloadImages: `Pobierz zdjęcia`,
    loading: `Wczytywanie zdjęć…`,
    noAccommodations: `Dla tego obiektu nie skonfigurowano jeszcze żadnych jednostek.`,
    engineCoverTag: `Okładka silnika`,
    imageCount: `{count} zdjęcie | {count} zdjęcia | {count} zdjęć`,
    hotelPhotosDesc: `Zdjęcia ogólne (dziedziniec, wejście, recepcja…), które klient zobaczy po otwarciu silnika`,
    dragToOrder: `Przeciągnij, aby uporządkować galerię`,
    ordering: `Porządkowanie…`,
    dragTip: `Przeciągnij`,
    hotelSectionName: `Zdjęcia hotelu · części wspólne`,
    orderUpdated: `Kolejność zdjęć zaktualizowana.`,
    orderError: `Nie udało się zaktualizować kolejności zdjęć.`,
    downloadError: `Nie udało się pobrać zdjęć.`,
  },
};
